var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.types[_vm.type] === 'service')?_c('search-single-service',{attrs:{"slug":_vm.slug}}):(_vm.types[_vm.type] === 'portofolio')?_c('search-single-project',{attrs:{"slug":_vm.slug}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }